"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M3 4.5a.5.5 0 0 1 .5-.5h1.248a2 2 0 0 1 1.968 1.642L6.78 6h10.438a1.5 1.5 0 0 1 1.455 1.864l-1 4A1.5 1.5 0 0 1 16.22 13H8.054l.214 1.179a1 1 0 0 0 .984.821H16.5a.5.5 0 0 1 0 1H9.252a2 2 0 0 1-1.968-1.642L5.732 5.82A1 1 0 0 0 4.748 5H3.5a.5.5 0 0 1-.5-.5M9.5 20a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M9 18.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0m6.5 1.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m-.5-1.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0"
}), 'EmptyBasketFilled');
//# sourceMappingURL=index.js.map